// extracted by mini-css-extract-plugin
export var dividerLine = "_3z-0";
export var errorBackground = "_3z-1";